import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import LoginForm from './loginForm';
import RegistrationForm from './registrationForm';
import ForgotPassword from './forgotPassword';
import TypeEmail from './typeEmail';
import AllForms from './allForms';

const LoginPage = () => {

  const { auth, user } = useContext(UserContext)
  const navigate = useNavigate()

  if (auth && typeof user !== 'undefined' && user.verified) {
    return navigate('/')
  }

  return (
    <div className="w-full flex min-h-lvh h-full">
      <div className="hero-bg absolute md:relative w-full min-h-lvh h-full md:h-auto">
        <div className="absolute w-full h-full bg-gradient-to-r from-indigo-500 to-emerald-500 rounded-2xl opacity-30"></div>
      </div>
      <div className="w-full justify-center flex items-center z-10 md:h-full md:min-h-lvh relative">
        <div className="p-8 sm:p-12 w-[80%] sm:w-[500px] h-fit my-[104px] lg:my-[106px] relative md:static bg-white">
          <AllForms />
        </div>
      </div>
    </div>
  )
}

export default LoginPage
